import request from '@/router/axios'

export function fetchList(query) {
    return request({
        url: '/basic/admin/page/page',
        method: 'get',
        params: query
    })
}

export function addBasicPage(obj) {
    return request({
        url: '/basic/admin/page',
        method: 'post',
        data: obj
    })
}

export function editBasicPage(obj) {
    return request({
        url: '/basic/admin/page',
        method: 'put',
        data: obj
    })
}

export function deleteBasicPage(id) {
    return request({
        url: `/basic/admin/page/${id}`,
        method: 'delete'
    })
}

export function getBasicPageById(id) {
    return request({
        url: `/basic/admin/page/${id}` ,
        method: 'get'
    })
}